import { isArray, isObject } from 'lodash'
import KyeDataStatistic from '../../kye-data-statistic'
const PREFIX = 'data-statistic-'
export default {
  name: 'DataStatisticWrap',
  functional: true,
  render (h, context) {
    const dataStatisticCell = context.parent.$scopedSlots.dataStatisticCell || context.parent.$slots.dataStatisticCell
    const dataStatisticOption = context.parent.$scopedSlots.dataStatisticOption || context.parent.$slots.dataStatisticOption
    const renderDataCol = () => {
      const data = isArray(context.props.dataStatisticOption) ? context.props.dataStatisticOption : [context.props.dataStatisticOption]
      const emitMapIter = (index) => ['cell-click', 'cell-label-click', 'cell-value-click', 'select'].reduce((obj, eventName) => {
        const name = PREFIX + eventName
        obj[name] = (...args) => {
          context.parent.$emit(name, ...[...args, index])
        }
        return obj
      }, {})
      return data.map((ele, index) => isObject(ele) ? <KyeDataStatistic {...{props: ele, on: emitMapIter(index)}}>
        {{
          cell: dataStatisticCell,
          option: dataStatisticOption
        }}
      </KyeDataStatistic> : null)
    }
    const inner = renderDataCol()
    return <div>
      {
        inner
      }
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/data-statistic/data-statistic-wrap.js